import { initializeClarity } from "utils/clarity";

/* istanbul ignore next */
const init = () => {
  const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

  if (!clarityProjectId) {
    return;
  }

  initializeClarity({
    projectId: clarityProjectId,
  });
};

export default init;
